module.exports = __webpack_public_path__ + "img/badge-most-created-leads-gold.3fd8b648.png";